
<template>
  <Cheader name="header"></Cheader>
</template>


<script>
export default {
  props: {
    percentNum: Number,
    titleName: String,
    width: String,
    isShow: {
      type: Boolean,
      default: true
    }
  },
/*  data() {
    return {
      num: ''
    };
  },
  watch: {
    $route(to, from) {
      this.num = this.commonJs.getTopTitle(this.$route.path)
        ? this.commonJs.getTopTitle(this.$route.path).percentNum
        : 0;
    }
  },
  created() {
    this.num = this.commonJs.getTopTitle(this.$route.path)
      ? this.commonJs.getTopTitle(this.$route.path).percentNum
      : 0;
  },
  methods: {
    clickbtn() {
      this.$emit('clickbtn');
    }
  }*/
};
</script>

<style lang="less"  scoped>
.cTopTitle-container {
  background-color: #fff;
  .container-by{
    height: 1rem;
    max-width: 6.8rem;
    margin: 0 auto;
    display: flex;
    align-items: center;
    padding: 0 0.2rem;
  }
  .cTopTitleLeft {
    width: 0.6rem;
    height: 0.6rem;
  }
  .cTopTitleRight {
    p {
      font-size: 0.16rem;
      color: #333333;
      margin-left: 0.2rem;
      font-weight: bold;
      white-space: pre-line;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Title/cTopTitle.vue